import React, { useState } from 'react'

const testimonials = [
  {
    name: "Tavon Bryan",
    role: "CEO/Founder",
    company: "Ebenezer Drafting & Construction Ltd.",
    content: "At Ebenezer Drafting and Construction Ltd., we are beyond satisfied with the exceptional services provided. They designed our company logo with outstanding creativity and attention to detail, capturing our vision perfectly. Their professionalism, high-quality results, and cost-efficient solutions have made them an invaluable partner.",
    image: "/clients/tavon-bryan.jpg",
  },
  {
    name: "Joel Lewis",
    role: "CEO",
    company: "Concepts of Thoughts",
    content: "The design team is great. They are fast, reliable, easy to work with, and always keen to do some explorations to find the best concept possible for any icon. I hope to keep working with them in the future!",
    image: "/clients/robin-naguier.jpg",
  },
  {
    name: "Sarah Chen",
    role: "CEO",
    company: "Palm Success",
    content: "Outstanding work on our product redesign. The attention to detail and user-centric approach really shows in the final result. Highly recommended!",
    image: "/clients/sarah-chen.jpg",
  },
]

export function Testimonials() {
  const [current, setCurrent] = useState(0)

  const prev = () => setCurrent(i => (i === 0 ? testimonials.length - 1 : i - 1))
  const next = () => setCurrent(i => (i === testimonials.length - 1 ? 0 : i + 1))

  const t = testimonials[current]

  return (
    <section
      className="bg-white py-16 sm:py-20 lg:py-28"
    >
      <style>{`
        .testi-tag {
          display: inline-block;
          font-size: 10px;
          font-weight: 600;
          letter-spacing: 0.15em;
          text-transform: uppercase;
          padding: 4px 12px;
          border: 1px solid #d4d4d4;
          border-radius: 999px;
          color: #666;
        }

        .testi-divider {
          width: 100%;
          height: 1px;
          background: #efefef;
        }

        .testi-card {
          position: relative;
          border: 1px solid #efefef;
          border-radius: 14px;
          overflow: hidden;
          background: #fafaf9;
          display: grid;
          grid-template-columns: 1fr;
        }

        .testi-content-col {
          padding: 44px 48px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          gap: 28px;
        }

        @media (max-width: 640px) {
          .testi-content-col {
            padding: 28px 24px;
          }
        }

        .testi-quote-mark {
          font-family: 'Playfair Display', Georgia, serif;
          font-size: 80px;
          line-height: 0.7;
          color: #ebe8e3;
          user-select: none;
          pointer-events: none;
          display: block;
          margin-bottom: 8px;
        }

        .testi-content {
          font-size: clamp(14px, 1.6vw, 17px);
          color: #555;
          line-height: 1.85;
          font-style: italic;
        }

        .testi-name {
          font-weight: 700;
          font-size: 18px;
          color: #111;
          line-height: 1.2;
        }

        .testi-role {
          font-size: 12px;
          color: #999;
          font-weight: 500;
          letter-spacing: 0.04em;
          margin-top: 3px;
        }

        .testi-nav-btn {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          border: 1px solid #e0e0e0;
          background: white;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s ease;
          flex-shrink: 0;
        }

        .testi-nav-btn:hover {
          border-color: #111;
          background: #111;
          color: white;
        }

        .testi-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #ddd;
          transition: background 0.3s, transform 0.3s;
          cursor: pointer;
          border: none;
          padding: 0;
        }

        .testi-dot.active {
          background: #111;
          transform: scale(1.3);
        }

        .testi-fade {
          animation: testiFade 0.3s ease;
        }

        @keyframes testiFade {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-16">

        <div className="testi-divider mb-12" />

        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12">
          <div>
            <p className="testi-tag mb-4">Testimonials</p>
            <h2 style={{
              fontWeight: 700,
              fontSize: "clamp(24px, 3.5vw, 42px)",
              lineHeight: 1.15,
              color: "#111",
            }}>
              What clients{" "}
              <span style={{ fontFamily: "'Playfair Display', Georgia, serif", fontStyle: "italic", fontWeight: 400, color: "#b91c1c" }}>say about us</span>
            </h2>
          </div>

          {/* Nav */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px", flexShrink: 0 }}>
            <button className="testi-nav-btn" onClick={prev} aria-label="Previous">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M19 12H5M5 12l7 7M5 12l7-7" />
              </svg>
            </button>
            <button className="testi-nav-btn" onClick={next} aria-label="Next">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M5 12h14M13 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>

        {/* Card */}
        <div className="testi-card testi-fade" key={current}>

          {/* Content column */}
          <div className="testi-content-col">
            <div>
              <span className="testi-quote-mark">"</span>
              <p className="testi-content">{t.content}</p>
            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "16px" }}>
              {/* Author info */}
              <div>
                <div className="testi-name">{t.name}</div>
                <div className="testi-role">{t.role} · {t.company}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="testi-divider mt-12" />

      </div>
    </section>
  )
}